
    <kv-datatable
        [allowsMultiSelection]="false"
        id="dt_classification_details"
        sectionTitle="{{ 'common.classification_details_title' | translate }}"
        listTitle="{{ 'common.classification_details_list_title' | translate }}"
        [numRowsPerPage]="10"
        [titles]="titles"
        [items]="this.svc.details"
        deleteButton="{{ 'common.delete' | translate }}"
        addButton="{{ 'common.add' | translate }}"
        (onAdd)="showAddDialog($event)"
        (onCancelDetail)="this.svc.editingDetail=null"
        [editable]="true"
        (onEditInline)="onEditInline($event)"
        (onDelete)="onDeleteInline($event)"
        [customButtons]="customButtons"
        (onCustomButton)="onCustomButton($event)"
    >
      <app-classification-details-form
          *ngIf="this.svc.editingDetail"
          [editingElement]="this.svc.editingDetail"
          (onAddElement)="onAdd($event)"
      >
      </app-classification-details-form>
    </kv-datatable>
  


// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification-details.component.ts.ClassificationDetails2Component.html